module.exports = __webpack_public_path__ + "static/img/live-hr-advice.31aac24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/live-hr-advice.png
// module id = bMhQ
// module chunks = 0